module.exports = __webpack_public_path__ + "img/elephant.efa9e101.png";